<template>
  <main id="verify" class="page __no-header">
    <div class="wrapper">
      <div class="grid">
        <section>
          <router-link tag="a" :to="{ name: 'home' }">
            <img src="img/logos/logo_full@2x.png" alt="">
          </router-link>
        </section>
        <section class="content">
          <div>
            <h4>Confirmando o seu e-mail...</h4>
            <p v-if="invalid">Link incompleto. Abra o link do e-mail novamente.</p>
          </div>
          <footer>
            <p>
            &copy; 2019 Todos os direitos reservados. RACE é uma marca registrada pelo INPI.
            </p>
            <nav>
              <ul>
                <router-link tag="li" :to="{ name: 'home' }">INÍCIO</router-link>
                <router-link tag="li" :to="{ name: 'services' }">SERVIÇOS</router-link>
                <router-link tag="li" :to="{ name: 'network' }">REDE</router-link>
                <router-link tag="li" :to="{ name: 'about' }">EMPRESA</router-link>
                <router-link tag="li" :to="{ name: 'contact' }">CONTATO</router-link>
              </ul>
            </nav>
          </footer>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
// O link do e-mail traz ?email=...&token=... (token de uso unico). Esta pagina so repassa
// os dois para a tela de definir senha (updatep), que chama a API.
export default{
  name: 'verify',
  data () {
    return {
      invalid: false
    }
  },
  mounted () {
    const { email, token } = this.$route.query
    if (!email || !token) {
      this.invalid = true
      return
    }
    this.$router.replace({ name: 'updatep', query: { email, token, mode: 'activate' } })
  }
}
</script>
